<template>
  <su-page>
    <el-row class="dataList" slot="content">
      <list-item :item="item" v-for="(item,index) in list" :key="index" @detailsClick="detailsClick(item)"/>
      <el-empty :image-size="100" v-if="!list || list.length == 0"></el-empty>
      <div class="flex ju-cn mt15">
        <pagination
            v-show="total > 0"
            :total="total"
            layout="prev, pager, next"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.size"
            @pagination="getList"
        />
      </div>
    </el-row>
  </su-page>
</template>
<script>

import {getNewsList} from "@/api/api";

export default {
  data() {
    return {
      list: [],
      // 总条数
      total: 0,
      queryParams: {
        page: 1,
        size: 10,
        cate_id: '1',
      },
    }
  },
  mounted() {
    this.getList();
  },
  created() {

  },
  methods: {
    // 详情
    detailsClick(data) {
      this.$router.push({
        path: '/latestNews/newsInformation/details',
        query: {
          id: data.id,
          cate_id: this.queryParams.cate_id,
        }
      });
    },
    // 列表
    getList() {
      this.loading = true;
      getNewsList(this.queryParams).then(response => {
        this.loading = false;
        this.list = response.data.data || [];
        this.total = response.data.total || 0;
      }).catch(error => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.dataList {

}
</style>
